var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-terms tc-gr__row tc-gr--justify-content-left"},[_c('rich-text-container',{staticClass:"tc-gr__col",attrs:{"document":_vm.termsInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }